import { useIdentity } from 'src/core/services/authentication';
import { useCurrentUserPermissionCheckInMainOrg } from '../permission-hooks';
import { PermissionsConstants } from '../types';

export const useCheckGlobalLicensesPermission = () => {
  const identity = useIdentity();
  const [hasPermission, isLoading] = useCurrentUserPermissionCheckInMainOrg(identity, PermissionsConstants.ManageGlobalLicenses);
  return [hasPermission, isLoading];
};
